import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37c07442"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "table-doc"
}
const _hoisted_2 = ["body-data"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sdds-header-cell", {
  "column-key": "code",
  "column-title": "FPC code",
  "custom-width": "250px"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sdds-header-cell", {
  "column-key": "descripcion",
  "column-title": "Operation",
  "custom-width": "250px"
}, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "table-doc"
}
const _hoisted_7 = ["body-data"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sdds-header-cell", {
  "column-key": "code",
  "column-title": "FPC code",
  "custom-width": "250px"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sdds-header-cell", {
  "column-key": "descripcion",
  "column-title": "Application",
  "custom-width": "250px"
}, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 4 }

import { computed } from 'vue';
// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'FileImporterHelpDoc',
  props: {
    idDrop: {
        type: String,
        default: null,
        required: true,
    },
},
  setup(__props) {

const props = __props



const appData = [{ code: '02758AA', descripcion: 'General cargo transport' },
{ code: '02758AB', descripcion: 'Volume transport' },
{ code: '02758AC', descripcion: 'Temperature controlled transport' },
{ code: '02758AD', descripcion: 'Bulk transport' },
{ code: '02758AE', descripcion: 'Vehicle transport' },
{ code: '02758AF', descripcion: 'Fuel transport' },
{ code: '02758AG', descripcion: 'Bulk ADR transport' },
{ code: '02758AH', descripcion: 'Grain transport' },
{ code: '02758AI', descripcion: 'Livestock transport' },
{ code: '02758AJ', descripcion: 'Aircraft refuelling' },
{ code: '02758AK', descripcion: 'Recovery' },
{ code: '02758AL', descripcion: 'Refuse collection' },
{ code: '02758AM', descripcion: 'Fire engine' },
{ code: '02758AN', descripcion: 'Airport crash tenders' },
{ code: '02758AO', descripcion: 'Aerial platform' },
{ code: '02758AP', descripcion: 'Vacuum/Sewer cleaning' },
{ code: '02758AQ', descripcion: 'Heavy haulage transport' },
{ code: '02758AR', descripcion: 'Tipper' },
{ code: '02758AS', descripcion: 'Concrete mixer' },
{ code: '02758AT', descripcion: 'Concrete pump' },
{ code: '02758AU', descripcion: 'Hooklift' },
{ code: '02758AV', descripcion: 'Skiploader' },
{ code: '02758AX', descripcion: 'Flatbed with crane' },
{ code: '02758AY', descripcion: 'Timber transport' },
{ code: '02758BA', descripcion: 'Wood chip transport' },
{ code: '02758BB', descripcion: 'Sugar cane transport' },
{ code: '02758BC', descripcion: 'Mobile crane' },
{ code: '02758BF', descripcion: 'Road sweeping' },
{ code: '02758BG', descripcion: 'Water/Foam carrier' },
{ code: '02758BH', descripcion: 'Turntable ladder' },
{ code: '02758BI', descripcion: 'Airport deicing' },
{ code: '02758BJ', descripcion: 'Airport sweeping' },
{ code: '02758BK', descripcion: 'Swap body transport' },
{ code: '02758BL', descripcion: 'Aircraft catering' },
{ code: '02758BM', descripcion: 'Shipping container transport' },
{ code: '02758BN', descripcion: 'Milk collection' },
]
const applicationData = computed(() => JSON.stringify(appData));


const operData = [{ code: '02759A', descripcion: 'Urban' },
{ code: '02759B', descripcion: 'Regional' },
{ code: '02759C', descripcion: 'Long distance' },
]

const operationData = computed(() => JSON.stringify(operData));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.idDrop === 'operationVariantCode')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("sdds-table", {
            "table-title": "Operation Variant Codes",
            "body-data": _unref(operationData),
            filtering: "",
            pagination: "",
            "rows-per-page": "5",
            "no-min-width": ""
          }, _hoisted_5, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    (__props.idDrop === 'applicationVariantCode')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("sdds-table", {
            "table-title": "Application Variant Codes",
            "body-data": _unref(applicationData),
            filtering: "",
            pagination: "",
            "rows-per-page": "5",
            "no-min-width": ""
          }, _hoisted_10, 8, _hoisted_7)
        ]))
      : _createCommentVNode("", true),
    (__props.idDrop === 'origin')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Here you map information about social media channel and accepted values are facebook, linkedin, instagram "))
      : _createCommentVNode("", true),
    (__props.idDrop === 'operationType')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Here you map Customer interest in Truck, bus or other services "))
      : _createCommentVNode("", true),
    (__props.idDrop === 'emailMarketing')
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Here you provide \"yes\" or \"no\" if customer opted for email marketing "))
      : _createCommentVNode("", true)
  ], 64))
}
}

})